import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
	MotifErrorMessage,
	MotifModalBody,
	MotifModalFooter,
	MotifModal,
	MotifModalHeader,
} from "@ey-xd/motif-react";
import Button from "@/components/Form/Button/Button";
import {
	SCHEME_NAME,

	SCHEME_DESC_NAME,
	SCHEME_NAME_FR,

	SCHEME_DESC_FR_NAME,
} from "./Constants";
import { CreateSchemeFormType } from "./type";
import ControlInputBox from "./ControlInputBoxScheme";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import ControlTextAreaWithCharLimit from "@/components/Form/InputBox/ControlTextAreaWithCharLimit";
import { useUpdateSchemeMutation } from "@/services/scheme/schemeReducer";
import { useTranslation } from "react-i18next";
import { SAVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import NotificationGrid from "@/components/Notification/NotificationGrid";

const EditScheme = ({
	show,
	setShow,
	editData,
	refetch,
}: any) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const [isDiscardVisible, setIsDiscardVisible] = useState(false);
	const [showMessage, setShowMessage] = useState({
		show: false,
		type: "error",
		message: "",
	  });
	const {
		handleSubmit,
		control,
		reset,
		formState: { errors,isDirty },
	} = useForm<CreateSchemeFormType>({
		defaultValues: {
			[SCHEME_NAME]: "",
			[SCHEME_NAME_FR]: "",
			[SCHEME_DESC_NAME]: "",
			[SCHEME_DESC_FR_NAME]: "",
		},
	});
	const handleClose = () => {
		setIsDiscardVisible(false);
		setShow(false);
	};
	const [updateScheme] = useUpdateSchemeMutation();
	const onSubmit = async (formData: CreateSchemeFormType) => {
		let schemeEditData = {
			id: editData?.id,
			name: formData.schemeName,
			nameFrench: formData.schemeFrName,
			description: formData.schemeDescName,
			descriptionFrench: formData.shemeDescFrName,
		};
		setIsLoading(true);
		const response = await updateScheme(schemeEditData);
		//@ts-ignore
		if (response?.data === true) {
			refetch();
			setShow(false);
			setIsLoading(false);
		} else {
			//@ts-ignore
			setStatusMsg();
			setIsLoading(false);
			setShowMessage({
				...showMessage,
				show: true,
				type: "error",
				//@ts-ignore
				message:   response?.error?.data?.message || t("pages.configuration.scheme.validationMessages.schemeFailed"),
			  });
		}
	};
	useEffect(() => {
		reset({
			schemeName: editData?.name || "",
			schemeDescName: editData?.description || "",
			schemeFrName: editData?.nameFrench || "",
			shemeDescFrName: editData?.descriptionFrench || "",
		  });
	}, [editData, reset]);
	return (
		<>
			<MotifModal
				className="create-edit-stage"
				onClose={() => {
					if(isDirty){
						setIsDiscardVisible(true);
					}
					else{
						handleClose();
					}
				}}
				show={show}
				focusTrapOptions={{
					tabbableOptions: {
						displayCheck: "none",
					},
				}}
			>
				<MotifModalHeader>{t("pages.configuration.scheme.editSchemeTitle")}</MotifModalHeader>

				<MotifModalBody>
					<form onSubmit={handleSubmit(onSubmit)}>
					{showMessage.show && (
						<NotificationGrid
							show={true}
							message={showMessage.message}
							type={showMessage.type}
						/>
					)}
						<div className="form-field mar-b-20">
							<ControlInputBox
								name={SCHEME_NAME}
								control={control}
								required={true}
								isTextArea={false}
								label={"pages.configuration.scheme.formLabels.schemeName"}
								showLabel={true}
								value={""}
							/>
							{errors[SCHEME_NAME] &&
								errors[SCHEME_NAME].type === "required" && (
									<MotifErrorMessage>{t("pages.configuration.scheme.validationMessages.schemeRequired")}</MotifErrorMessage>
								)}
						</div>
						<div className="form-field mar-b-20">
							<ControlInputBox
								name={SCHEME_NAME_FR}
								control={control}
								isTextArea={false}
								label={"pages.configuration.scheme.formLabels.schemeNameFrench"}
								showLabel={true}
								value={""}
							/>
						</div>
						<div className="form-field mar-b-20">
							<ControlTextAreaWithCharLimit
								name={SCHEME_DESC_NAME}
								control={control}
								isTextArea={true}
								label={"pages.configuration.scheme.formLabels.schemeDescription"}
								showLabel={true}
							/>
						</div>
						<div className="form-field">
							<ControlTextAreaWithCharLimit
								name={SCHEME_DESC_FR_NAME}
								control={control}
								isTextArea={true}
								label={"pages.configuration.scheme.formLabels.schemeDescriptionFrench"}
								showLabel={true}
							/>
						</div>
					</form>
				</MotifModalBody>

				<MotifModalFooter>
					<Button
						label={t("global.globalActions.save")}
						variant={SAVE_BUTTON_VARIANT}
						className="motif-button"
						onClickHandler={handleSubmit(onSubmit)}
						type={isLoading ? "loader" : "submit"}
						disabled={isLoading}
					/>
				</MotifModalFooter>
			</MotifModal>
			<ConfirmationModal
				isVisible={isDiscardVisible}
				setIsVisible={setIsDiscardVisible}
				cancelBtnApproveHandler={handleClose}
				cancelBtnRejectHandler={() => setIsDiscardVisible(false)}
			/>
		</>
	);
};
export default EditScheme;
